var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoCircleLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_4419)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.64999C8.27614 7.64999 8.5 7.87385 8.5 8.14999V11.65C8.5 11.9261 8.27614 12.15 8 12.15C7.72386 12.15 7.5 11.9261 7.5 11.65V8.14999C7.5 7.87385 7.72386 7.64999 8 7.64999Z",
    fill: "#66B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4251 4.88467C8.68167 5.11558 8.70247 5.51076 8.47156 5.76733L8.46456 5.77511C8.23365 6.03168 7.83847 6.05248 7.5819 5.82156C7.32533 5.59065 7.30453 5.19547 7.53544 4.9389L7.54244 4.93113C7.77335 4.67456 8.16853 4.65376 8.4251 4.88467Z",
    fill: "#66B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.375C4.34111 1.375 1.375 4.34111 1.375 8C1.375 11.6589 4.34111 14.625 8 14.625C11.6589 14.625 14.625 11.6589 14.625 8C14.625 4.34111 11.6589 1.375 8 1.375ZM0.625 8C0.625 3.9269 3.9269 0.625 8 0.625C12.0731 0.625 15.375 3.9269 15.375 8C15.375 12.0731 12.0731 15.375 8 15.375C3.9269 15.375 0.625 12.0731 0.625 8Z",
    fill: "#66B6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_4419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoCircleLined);
export default __webpack_public_path__ + "static/media/ic_info_circle_lined.c67c2f26414073f3fec1c86de7aa8c4e.svg";
export { ForwardRef as ReactComponent };